<app-page-container [hidden]="!(mode === 'List')" [DataTableSchema]="dataTableSchema" [title]="title"
  [dynamicFormArray]="filterSchema" [props]="props">
</app-page-container>

@if(mode === 'View'){
  <job-history-detail [dataSet]="dataSet" (dataEmitter)="onDetailViewChange($event)"></job-history-detail>
}
